import { api } from "@/lib/api";
import { trackUmamiEvent } from "@/lib/umamiAnalytics";

function clean(value, maxLength = 120) {
  if (typeof value !== "string") return undefined;
  const normalized = value.trim();
  return normalized ? normalized.slice(0, maxLength) : undefined;
}

export function trackProductEvent(eventName, payload = {}) {
  if (!eventName) return;

  const body = {
    event_name: eventName,
    page_path: clean(payload.page_path || window.location.pathname, 300),
    section: clean(payload.section, 80),
    outcome: clean(payload.outcome, 80),
    call_count: Number.isFinite(payload.call_count) ? payload.call_count : undefined,
  };

  trackUmamiEvent(eventName, {
    page_path: body.page_path,
    section: body.section,
    outcome: body.outcome,
    call_count: body.call_count,
  });

  api.post("/events/product", body).catch(() => {
    // Product analytics must never interrupt the beta workflow.
  });
}
